import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

const Popup = ({ itemCount, desktop, onResult, state }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`${styles.popup} ${
        desktop ? styles['popup--desktop'] : styles['popup--mobile']
      }`}
    >
      <p>
        <span>
          {itemCount} ITEM{itemCount > 1 ? 'S' : ''}
        </span>{' '}
        {t('tool_ui.popup.added_to')}
      </p>
      <button onClick={() => onResult(state.selectedAccessories)}>
        {t('tool_ui.popup.view_final')}
      </button>
    </div>
  );
};

export default Popup;
